import React from 'react'
import { Pagination } from 'react-bootstrap'
import Select from '../../../components/form/Select'

export default function Paginator({
    params,
    setData,
    setFullWidth,
    fullwidth,
    hiddenpaginator
}) {
    const { totalPages, currentPage, pageSize } = params
    const handleChange = (e) => {
        // setPerPage(e.target.value)
        // setData((prevData) => ({
        //     ...prevData,
        //     data: {
        //         ...prevData.data,
        //         pageSize: e.target.value,
        //     },
        // }));
        setData((prevData) => ({
            ...prevData,
            params: {
                ...prevData.params,
                pageSize: Number(e.target.value),
            },
        }));
    }

    const setCurrentPage = (num) => {
        setData((prevData) => ({
            ...prevData,
            params: {
                ...prevData.params,
                currentPage: Number(num),
            },
        }));
    }
    return (
        <div className="row px-0 py-1">
            {
                !hiddenpaginator ?
                    <>
                        <div className="col col-5 d-flex justify-content-start">
                            <Select
                                value={pageSize}
                                title={'cantidad de registros por página'}
                                onChange={handleChange}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </Select>
                            <button
                                className="ml-1 btn py-0 bg-danger rounded px-3"
                                onClick={() => setData((a => ({ ...a, recall: !a.recall })))}
                                style={{
                                    alignItems: 'center',
                                    verticalAlign: 'middle'
                                }}
                                disabled={'true' === "loading..." ? true : false}
                            >
                                <i className="ion-loop h5" />
                            </button>
                            <button
                                className="ml-1 btn d-none d-md-block py-0 bg-secondary rounded px-3"
                                onClick={() => setFullWidth(x => !x)}
                                style={{
                                    alignItems: 'center',
                                    verticalAlign: 'middle'
                                }}
                                disabled={'stateData' === "loading..." ? true : false}
                            >
                                <i className={`bi bi-${fullwidth ? 'arrows-angle-contract' : 'arrows-angle-expand'} h6 px-0`} />
                            </button>
                        </div>
                        <div className="col col-7 d-flex justify-content-end">
                            <Pagination size='md' className='p-0 m-0 fw-bold'>
                                <Pagination.First style={{ fontSize: '40px' }} onClick={() => setCurrentPage(1)} disabled={currentPage <= 1 && true} />
                                <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage <= 1 && true} />
                                <Pagination.Item active>{currentPage}</Pagination.Item>
                                <Pagination.Next onClick={() => setCurrentPage(currentPage + 1)} disabled={totalPages <= currentPage && true} />
                                <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={totalPages <= currentPage && true} />
                            </Pagination>
                        </div>
                    </>
                    :
                    <div className="col col-12 d-flex justify-content-end">
                        <Pagination size='md' className='p-0 m-0 fw-bold'>
                            <Pagination.First style={{ fontSize: '40px' }} onClick={() => setCurrentPage(1)} disabled={currentPage <= 1 && true} />
                            <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage <= 1 && true} />
                            <Pagination.Item active>{currentPage}</Pagination.Item>
                            <Pagination.Next onClick={() => setCurrentPage(currentPage + 1)} disabled={totalPages <= currentPage && true} />
                            <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={totalPages <= currentPage && true} />
                        </Pagination>
                    </div>
            }
        </div>
    )
}
